import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "../../TechPlatform/TechCBT/TechCBT.css";

const TechApp = () => {
  return (
    <>
      <div className="TechCBT mb-5">
        <div className="container">
          <div className="row px-lg-5 flex-column-reverse flex-md-row">
            <div className="col-md-6">
              <div className="d-flex justify-content-center me-xxl-5 pe-xxl-4 me-lg-3">
                <LazyLoadImage
                  src="https://blueberrywebsites.azureedge.net/bbt/images/travellerApp.png"
                  alt=""
                  className="cbt-image"
                  loading="lazy"
                />
              </div>
            </div>
            <div className="col-md-6">
              <h1 className="headings">
                <span>Blueberry </span>Traveller App
              </h1>
              <p className="greotesk-headings cbt-description">
                In a rush for a business meeting? Let our Traveler App handle
                it! From flight tracking to expense tracking, our app offers a
                comprehensive suite of features to simplify every aspect of your
                travel experience.
              </p>
              <div className="row mt-4">
                <div className="col-md-6">
                  <div className="cbt-card1">
                    <LazyLoadImage
                      src="https://blueberrywebsites.azureedge.net/bbt/images/apptracker.png"
                      alt=""
                      loading="lazy"
                    />
                    <p className="greotesk-headings cbt-p">Flight Tracker</p>
                  </div>
                </div>
                <div className="col-md-6 mt-3 mt-md-0">
                  <div className="cbt-card1 cbt-card2">
                    <LazyLoadImage
                      src="https://blueberrywebsites.azureedge.net/bbt/images/appWeather.png"
                      alt=""
                      loading="lazy"
                    />
                    <p className="greotesk-headings cbt-p">Weather Forecasts</p>
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-6">
                  <div className="cbt-card1 cbt-card3">
                    <LazyLoadImage
                      src="https://blueberrywebsites.azureedge.net/bbt/images/appCurrency.png"
                      alt=""
                      loading="lazy"
                    />
                    <p className="greotesk-headings cbt-p">
                      Currency Converter
                    </p>
                  </div>
                </div>
                <div className="col-md-6   mt-3 mt-md-0">
                  <div className="cbt-card1 cbt-card4">
                    <LazyLoadImage
                      src="https://blueberrywebsites.azureedge.net/bbt/images/appItinerary.png"
                      alt=""
                      loading="lazy"
                    />
                    <p className="greotesk-headings cbt-p">Itinerary Builder</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TechApp;
